var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72Ms7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.39,16.25c0,.7-.57,1.27-1.27,1.27s-1.27-.57-1.27-1.27,.57-1.27,1.27-1.27,1.27,.57,1.27,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.94,11.23c-.17,.18-.4,.27-.63,.27-.21,0-.43-.08-.6-.24l-2.71-2.57-2.71,2.57c-.35,.33-.9,.32-1.23-.03-.33-.35-.32-.9,.03-1.23l3.31-3.13c.34-.32,.86-.32,1.2,0l3.31,3.13c.35,.33,.36,.88,.03,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.94,20.77c-.17-.18-.4-.27-.63-.27-.21,0-.43,.08-.6,.24l-2.71,2.57-2.71-2.57c-.35-.33-.9-.32-1.23,.03-.33,.35-.32,.9,.03,1.23l3.31,3.13c.34,.32,.86,.32,1.2,0l3.31-3.13c.35-.33,.36-.88,.03-1.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Ms7);
export default __webpack_public_path__ + "static/media/72-ms-7.80a764d2921888ff3d64d786a86161c2.svg";
export { ForwardRef as ReactComponent };